import { render } from "./Verifikasi.vue?vue&type=template&id=4f0a342b&scoped=true"
import script from "./Verifikasi.vue?vue&type=script&lang=js"
export * from "./Verifikasi.vue?vue&type=script&lang=js"

import "./Verifikasi.vue?vue&type=style&index=0&id=4f0a342b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0a342b"]])

export default __exports__